module.exports = __webpack_public_path__ + "img/maoxing.5c161033.jpg";